module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Pantone-59d34bd030c6d9d3d3828792d82fdd5a.svg";